import {
  IntervalUnit,
  type SnoozeActionData,
  type DelayDuration,
} from '@/proto/logiblocks/logiblocks';

/**
 * The largest duration the stored field can hold: it is a 32-bit number of seconds, about 68
 * years. This is a limit of the format, not a product limit on how long a snooze may be, and it
 * only exists so an absurd amount is flagged instead of wrapping around when it is saved.
 */
export const MAX_STORABLE_SNOOZE_SECONDS = 2 ** 31 - 1;

/**
 * Default snooze duration: 30 minutes. Used as a fallback when the node is in
 * UNTIL_TIME mode and the user switches into DURATION.
 */
export const DEFAULT_SNOOZE_DURATION: DelayDuration = {
  seconds: 1800,
  display_unit: IntervalUnit.MINUTES,
};

/**
 * Default snooze action data: 30 minutes.
 */
export const DEFAULT_SNOOZE_ACTION: SnoozeActionData = {
  duration: DEFAULT_SNOOZE_DURATION,
};
